<template>
  <div
    class="inline-flex h-6 items-center rounded-full px-2.5 text-label-m-bold whitespace-nowrap text-icon-primary"
    :class="{
      'border border-primary-subtle bg-surface': variant === 'outlined',
      'bg-primary-subtle': variant === 'solid',
    }"
  >
    <button v-if="hasDestroyEventListener" data-testid="btn-destroy" class="mr-1" @click="emit('destroy')">
      <Trash2Icon class="ml-1 lucide-icon-s" />
    </button>
    <button
      :disabled="moveUpDisabled"
      data-testid="btn-move-up"
      class="mr-1"
      :class="{ 'text-primary-subtle': moveUpDisabled }"
      @click="emit('moveUp')"
    >
      <ArrowUpIcon class="ml-1 lucide-icon-s" />
    </button>
    <button
      :disabled="moveDownDisabled"
      data-testid="btn-move-down"
      class="mr-1"
      :class="{ 'text-primary-subtle': moveDownDisabled }"
      @click="emit('moveDown')"
    >
      <ArrowDownIcon class="ml-1 lucide-icon-s" />
    </button>
  </div>
</template>
<script setup lang="ts">
import { ArrowUpIcon, ArrowDownIcon, Trash2Icon } from '@ramp106/omrjs-core-ui/icons'
import { computed, getCurrentInstance } from 'vue'

withDefaults(
  defineProps<{
    moveUpDisabled?: boolean
    moveDownDisabled?: boolean
    variant?: 'outlined' | 'solid'
  }>(),
  {
    moveUpDisabled: false,
    moveDownDisabled: false,
    variant: 'outlined',
  },
)

const emit = defineEmits(['destroy', 'moveUp', 'moveDown'])

const hasDestroyEventListener = computed(() => !!getCurrentInstance()?.vnode.props?.onDestroy)
</script>
